import { callAPI } from "../../network/networkConnection";
import { NetworkConfiguration } from "../../network/networkConfriguation";
import { getAuthLocalStorage } from "../../storage/localStorage";

const base = () => `${process.env.REACT_APP_APIUrl}${NetworkConfiguration.ADMIN_CANTON_FAIR_LEADS}`;

/**
 * Download Excel export (same filters as list; omit page/limit).
 */
export async function downloadCantonFairLeadsExcel(queryString = "") {
  const auth = getAuthLocalStorage();
  const token = auth?.loginHeader;
  const url = `${base()}/export${queryString}`;
  const res = await fetch(url, {
    method: "GET",
    headers: {
      Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/octet-stream",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
  if (!res.ok) {
    let msg = `Export failed (${res.status})`;
    try {
      const j = await res.json();
      msg = j?.status?.message || j?.error?.message || msg;
    } catch (_) {
      /* ignore */
    }
    throw new Error(msg);
  }
  const blob = await res.blob();
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = `canton-fair-leads-${new Date().toISOString().slice(0, 10)}.xlsx`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(a.href);
}

export const cantonFairLeadAdminApiService = {
  list(queryString = "") {
    return callAPI(`${base()}${queryString}`, "GET", { "Content-Type": "application/json" });
  },
  getById(id) {
    return callAPI(`${base()}/${id}`, "GET", { "Content-Type": "application/json" });
  },
  update(id, body) {
    return callAPI(`${base()}/${id}`, "PUT", { "Content-Type": "application/json" }, JSON.stringify(body));
  },
  remove(id) {
    return callAPI(`${base()}/${id}`, "DELETE", { "Content-Type": "application/json" });
  },
};


// -------------------------------- Exporterr supplier inquiries (supplierinquiries) --------------------------------
const supplierInquiriesAdminBase = () =>
  `${process.env.REACT_APP_APIUrl}${NetworkConfiguration.ADMIN_SUPPLIER_INQUIRIES}`;

/** Admin: paginated list (auth). Query string e.g. ?page=1&limit=20&q=… */
export const supplierInquiriesAdminList = (queryString = "") => {
  return callAPI(`${supplierInquiriesAdminBase()}${queryString}`, "GET", { "Content-Type": "application/json" });
};

/** Admin: update status / internal notes (auth). */
export const supplierInquiriesAdminPatch = (id, body) => {
  return callAPI(
    `${supplierInquiriesAdminBase()}/${id}`,
    "PATCH",
    { "Content-Type": "application/json" },
    JSON.stringify(body)
  );
};

/** Admin: full update of inquiry fields (auth). */
export const supplierInquiriesAdminUpdate = (id, body) => {
  return callAPI(
    `${supplierInquiriesAdminBase()}/${id}`,
    "PUT",
    { "Content-Type": "application/json" },
    JSON.stringify(body)
  );
};

/** Admin: delete inquiry (auth). Requires current user's login password in body. */
export const supplierInquiriesAdminDelete = (id, password) => {
  return callAPI(
    `${supplierInquiriesAdminBase()}/${id}`,
    "DELETE",
    { "Content-Type": "application/json" },
    JSON.stringify({ password: password ?? "" })
  );
};

/** Admin: Excel export with same filters as list (omit page/limit). */
export async function downloadSupplierInquiriesExcel(queryString = "") {
  const auth = getAuthLocalStorage();
  const token = auth?.loginHeader;
  const url = `${supplierInquiriesAdminBase()}/export${queryString}`;
  const res = await fetch(url, {
    method: "GET",
    headers: {
      Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/octet-stream",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
  if (!res.ok) {
    let msg = `Export failed (${res.status})`;
    try {
      const j = await res.json();
      msg = j?.status?.message || j?.error?.message || msg;
    } catch (_) {
      /* ignore */
    }
    throw new Error(msg);
  }
  const blob = await res.blob();
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = `supplier-inquiries-${new Date().toISOString().slice(0, 10)}.xlsx`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(a.href);
}
